import React, { useState } from 'react';

import './Modal.scss';

function Modal(props) {
    const classes = props.classes ? props.classes : [];
    const classString = classes.concat(['modal']).join(' ');
    const [title] = useState(!!props?.titleText ? props.titleText : null);

    return (
        <div className={classString}>
            {!!title ? (
                <>
                    <h2>{title}</h2>
                    <hr className="modal-title-break" />
                </>
            ) : null}
            <div
                className="modal-content"
                aria-modal="true"
                role="alertdialog"
            >
                {props.children}
            </div>
        </div>
    );
}

export default Modal;
